module.exports = __webpack_public_path__ + "static/Tobiasz_2_min-08ff8c6c0b481e0d062d5106b8b11811.jpg";